/**
 * Environment options for seed configurations
 */
export const ENVIRONMENTS = [
	{
		label: "Staging",
		value: "Staging",
	},
	{
		label: "Preview",
		value: "Preview",
	},
];

/**
 * Available configuration options for seed configurations
 */
export const SEED_CONFIGURATION_OPTIONS = [
	{
		label: "AutoFlow",
		id: "autoflow",
		value: "autoflow: enabled",
	},
	{
		label: "Engagement",
		id: "engagement",
		value: "engagement: true",
	},
	{
		label: "Feedback",
		id: "feedback",
		value: "feedback: enabled",
	},
	{
		label: "Public API",
		id: "apiKey",
		value: "apiKey: enabled",
	},
	{
		label: "Run ETLs",
		id: "runETLs",
		value: "run_etls: true",
	},
	{
		label: "SCIM",
		id: "scim",
		value: "scim: enabled",
	},
];
